import { DataBean } from "../DataBean";

export class QualityMeasurementInspectionsItems extends DataBean {

  public async getQualityMeasurementInspectionsItemsCatalogPorPropiedades( properties: any, maxRows: number ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "java.util.List_getQualityMeasurementInspectionsItemsCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async getQualityMeasurementInspectionsItemsRender( page: number, rows: number, properties: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.advantage.shared.Report_getQualityMeasurementInspectionsItemsRender_Number_Number_java.util.Map",
      [page, rows, properties]
    );
  }

  public async deleteQualityMeasurementInspectionsItems(idqualitymeasurementinspectionsitems: number): Promise<any> {
      return this.getCustomService("ProcessContractERP", "boolean_deleteQualityMeasurementInspectionsItems_Number", [idqualitymeasurementinspectionsitems]);
  }

  public async updateQualityMeasurementInspectionsItems(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.orange.finance.processcontract.bean.QualityMeasurementInspectionsItems_updateQualityMeasurementInspectionsItems_com.orange.finance.processcontract.bean.QualityMeasurementInspectionsItems",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.orange.finance.processcontract.bean.QualityMeasurementInspectionsItems",
        },
      ]
    );
  }
}
